import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COLOR, SIZE, URL, LABEL, FONT_FAMILY } from '../../utils/constants.js';
import TextButton from '../atoms/textbutton.jsx';

import PathIcHome from '../../icons/ic_home.svg';
import PathIcForward from '../../icons/ic_forward.svg';

const Content = styled.ul`
    display: flex;
    float: left;
    margin: ${props => props.margin ? props.margin : '0'};
`;


const Path = (props) => {

    var endpointsArray = props.endpoint.split("/")
    const endpointsElements = endpointsArray.map((pathString, index) => {
        var endpointUrl = null
        if (pathString === LABEL.thematics) {
            endpointUrl = URL.thematics
        }
        return (
            <li key={index}>
                <TextButton
                    key={index}
                    href={endpointUrl}
                    ic_path={PathIcForward}
                    ic_size='15px'
                    ic_color={COLOR.ferra}
                    text_color={COLOR.ferra}
                    text_size={SIZE.body}
                    font_family={FONT_FAMILY.noteworthyBold}
                    separation='4px' >
                    {pathString}
                </TextButton>
            </li>
        )
    });

    return (
        <Content
            margin={props.margin}>
            <li>
                <TextButton
                    href='/'
                    ic_path={PathIcHome}
                    ic_size='18px'
                    ic_color={COLOR.ferra}
                    text_color={COLOR.ferra}
                    text_size={SIZE.body}
                    font_family={FONT_FAMILY.noteworthyBold}
                    separation='4px' >
                    {LABEL.init} 
                </TextButton>
            </li>
            { endpointsElements }
        </Content>
    );
}

Path.propTypes = {
    endpoint: PropTypes.string,
    margin: PropTypes.string,
}

export default Path;